export default __webpack_public_path__ + "static/media/quiz-icon.5fb241dc.png";